import { css } from "lit";
export const sharedStyles = css `
:root {
    --left-gutter: 7.5%;
    --right-gutter: 7.5%;
}

h1 {
    font-family: var(--fonts-h1-font-family);
    font-weight: var(--fonts-h1-font-weight);
    font-size: var(--fonts-h1-font-size-mobile);
    font-display: swap;
    color: var(--black);
    margin-top: 0;
}

h2 {
    font-family: var(--fonts-h2-font-family);
    font-weight: var(--fonts-h2-font-weight);
    line-height: var(--fonts-h2-line-height);
    font-display: swap;
    font-size: 2rem;
    color: var(--ft-sky-blue);
    margin-top: 0;
}

h3 {
    font-family: var(--fonts-h3-font-family);
    font-weight: var(--fonts-h3-font-weight);
    line-height: var(--fonts-h3-line-height);
    font-display: swap;
    font-size: var(--fonts-h3-font-size-desktop);
    margin-top: 0;
}

h4 {
    font-family: var(--fonts-h4-font-family);
    font-weight: var(--fonts-h4-font-weight);
    line-height: var(--fonts-h4-line-height);
    font-display: swap;
    font-size: var(--fonts-h4-font-size-desktop);
    margin-top: 0;
}

a, p, li, dt, dd { 
    font-family: var(--base-font-family);
    font-weight: var(--font-weight-regular);
    line-height: var(--fonts-p-line-height);
    font-display: swap;
}

strong {
    font-family: var(--font-bold);
    font-weight: var(--font-weight-bold);
    font-display: swap;
}

@media (min-width: 768px) and (max-width: 1200px) {
    h1 { font-size: var(--fonts-h1-font-size-small-desktop); }
    h2 { font-size: var(--fonts-h2-font-size-small-desktop); }
    h3 { font-size: var(--fonts-h3-font-size-small-desktop); }
    h4 { font-size: var(--fonts-h4-font-size-small-desktop); }
}

@media (min-width: 1200px) and (max-width: 1600px) {

    h1 { font-size: var(--fonts-h1-font-size-small-desktop); }
    h2 { font-size: var(--fonts-h2-font-size-small-desktop); }
    h3 { font-size: var(--fonts-h3-font-size-small-desktop); }
    h4 { font-size: var(--fonts-h4-font-size-small-desktop); }    
}

@media (min-width: 1600px) and (max-width: 1900px) {
    h1 { font-size: var(--fonts-h1-font-size-desktop); }
    h2 { font-size: var(--fonts-h2-font-size-desktop); }
    h3 { font-size: var(--fonts-h3-font-size-desktop); }
    h4 { font-size: var(--fonts-h4-font-size-desktop); }
}

@media (min-width: 1900px) {
    h1 { font-size: var(--fonts-h1-font-size-large-desktop); }
    h2 { font-size: var(--fonts-h2-font-size-large-desktop); }
    h3 { font-size: var(--fonts-h3-font-size-large-desktop); }
    h4 { font-size: var(--fonts-h4-font-size-large-desktop); }
}

.final-shape {
    -webkit-animation: finalgradient 15s ease infinite;
    animation: finalgradient 15s ease infinite;
    background: linear-gradient(-45deg,#ee7752,#e73c7e,#23a6d5,#23d5ab);
    background-size: 400% 400%;
    left: 0;
    position: fixed;
    right: auto;
    z-index: 2
}

@-webkit-keyframes finalgradient {
    0% {
        background-position: 0 50%
    }

    50% {
        background-position: 100% 50%
    }

    to {
        background-position: 0 50%
    }
}

@keyframes finalgradient {
    0% {
        background-position: 0 50%
    }

    50% {
        background-position: 100% 50%
    }

    to {
        background-position: 0 50%
    }
}

/* ----------------------------------------------
 * Generated by Animista on 2024-12-16 12:38:41
 * Licensed under FreeBSD License.
 * See http://animista.net/license for more info. 
 * w: http://animista.net, t: @cssanimista
 * ---------------------------------------------- */
@keyframes fade-in-left {
  0% {
    transform: translateX(-50px);
    opacity: 0;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }
}
@keyframes fade-in-right {
  0% {
    transform: translateX(50px);
    opacity: 0;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }
}
@keyframes fade-in {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }



  .component {
    width: calc(100% - 4rem);
    margin: 2rem;
}

@media(min-width: 768px) {
    .component {
        max-width: 100%;
        margin: 0rem 2rem;
    }
}


  @media (min-width: 1200px) {  
    .component {
        max-width: 1200px;
        margin: 0 auto;
    }
}`;
//# sourceMappingURL=shared-styles.js.map